var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Akilli_Bahis",
    "data-name": "Akilli Bahis",
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.801,
    height: 14.524,
    viewBox: "0 0 11.801 14.524",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M28.965,113.165H17.9v-3.831c0-.427.186-.635.624-.635h9.785a.563.563,0,0,1,.646.624C28.965,110.593,28.965,111.841,28.965,113.165Z",
    transform: "translate(-17.5 -98.642)",
    fill: "#fafafa"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M15.248,59.216a1.408,1.408,0,0,1-1-1.445,1.233,1.233,0,0,1,1-1.171v2.616Z",
    transform: "translate(-14.246 -52.244)",
    fill: "#fafafa"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M113.2,59.439V56.9a1.186,1.186,0,0,1,.963,1.127A1.316,1.316,0,0,1,113.2,59.439Z",
    transform: "translate(-102.37 -52.511)",
    fill: "#fafafa"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M36.854,19.142h-2.2v-.657a.876.876,0,0,0,.591-.821.865.865,0,1,0-1.138.821v.657H30.988c-.635,0-.788.142-.788.766v5.035c0,.635.164.788.821.788H37.7c.733,0,.843-.12.843-.876v-4.05C38.54,19.011,38.726,19.142,36.854,19.142Zm-.919,1.335a.92.92,0,0,1,.919.9.92.92,0,1,1-1.839.044A.923.923,0,0,1,35.935,20.477Zm-3.1.011a.9.9,0,0,1,.887.908.91.91,0,0,1-.919.941.919.919,0,0,1-.887-.919A.882.882,0,0,1,32.838,20.488Zm4.093,4.3h-5.1v-1.4h5.1Z",
    transform: "translate(-28.454 -16.8)",
    fill: "#fafafa"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8a9c6aeffa98409878f73003ca95bc35.svg";
export { ForwardRef as ReactComponent };